/** Retain saved group links inside Practices without changing its directory search. */
export function practicesFromDentalGroups(params: URLSearchParams): string {
  const next = new URLSearchParams(params);
  next.set("groups", "1");
  if (next.has("q")) { next.set("groupQ", next.get("q")!); next.delete("q"); }
  if (next.has("assignment")) { next.set("groupAssignment", next.get("assignment")!); next.delete("assignment"); }
  return `/practices?${next}`;
}
